module.exports = __webpack_public_path__ + "assets/icons-misc-misc-arrowforward-24-px.d8609281.svg";